import {
  FormReducerActions,
  formState,
  setAuthorDetailTimeUsage,
  setAuthorEmail,
  setAuthorName,
  setReviewBodyText,
  setReviewConsText,
  setReviewProsText,
  setTotalScore,
} from '../state';
import { ReviewFormFieldError, ReviewFormProps } from '../types';

type ReviewFormMappedState = {
  fieldsErrors: ReviewFormFieldError[];
} & Pick<ReviewFormProps, 'totalScore'> &
  Pick<ReviewFormProps, 'body' | 'pros' | 'cons'> &
  Pick<ReviewFormProps, 'timeUsage' | 'shop' | 'authorName' | 'authorEmail'>;
export const mapStoreToProps = (state: ReturnType<typeof formState>): ReviewFormMappedState => {
  return {
    totalScore: state.totalScore,
    body: state.bodyText,
    pros: state.prosText,
    cons: state.consText,
    timeUsage: state.authorTimeUsage ?? null,
    shop: state.authorShop ?? null,
    authorName: state.authorName,
    authorEmail: state.authorEmail,
    fieldsErrors: state.fieldsErrors,
  };
};

type ReviewFormDispatchMap = Pick<ReviewFormProps, 'setTotalScore'> &
  Pick<ReviewFormProps, 'setReviewBodyText' | 'setReviewConsText' | 'setReviewProsText'> &
  Pick<ReviewFormProps, 'setTimeUsage' | 'setAuthorName' | 'setAuthorEmail'>;

export const mapDispatchToProps = (dispatch: React.Dispatch<FormReducerActions>): ReviewFormDispatchMap => ({
  setTotalScore: (score) => dispatch(setTotalScore(score)),
  setReviewBodyText: (text) => dispatch(setReviewBodyText(text)),
  setReviewConsText: (text) => dispatch(setReviewConsText(text)),
  setReviewProsText: (text) => dispatch(setReviewProsText(text)),
  setTimeUsage: (value, indexFromOne) =>
    dispatch(setAuthorDetailTimeUsage({ timeUsage: value, indexFromOne })),
  setAuthorName: (value) => dispatch(setAuthorName(value)),
  setAuthorEmail: (value) => dispatch(setAuthorEmail(value)),
});
